import gsap, { Cubic } from 'gsap';

const ease = Cubic.easeInOut();

export const animateSideBarMenu = ({
  refs,
  timeline,
  onComplete,
  reversed,
  onReverseComplete,
}) => {
  const { overlayRef, sideNavMenuRef } = refs?.current || {};

  timeline.current?.kill();
  timeline.current = gsap.timeline({
    onComplete,
    onReverseComplete,
    paused: true,
  });

  timeline.current
    .fromTo(
      overlayRef?.current,
      {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        pointerEvents: 'none',
      },
      {
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        pointerEvents: 'initial',
        duration: 0.2,
        delay: 0.1,
        ease: ease,
      },
      'together',
    )
    .fromTo(
      sideNavMenuRef?.current,
      {
        x: '-350px',
      },
      {
        x: 0,
        duration: 0.3,
        ease: ease,
      },
      'together',
    );

  if (reversed) {
    timeline.current.reverse(0);
  } else {
    timeline.current.play();
  }
};

export const menuAnimation = ({
  refs2,
  timeline2,
  onComplete,
  reversed,
  onReverseComplete,
}) => {
  const { menuRef } = refs2?.current || {};

  timeline2.current?.kill();
  timeline2.current = gsap.timeline({
    onComplete,
    onReverseComplete,
    paused: true,
  });

  timeline2.current.fromTo(
    menuRef?.current,
    {
      x: '0',
    },
    {
      x: '-350px',
      duration: 0.3,
      ease: ease,
    },
  );

  if (reversed) {
    timeline2.current.reverse(0);
  } else {
    timeline2.current.play();
  }
};

export const closeButtonAnimation = ({
  refs3,
  timeline3,
  onComplete,
  reversed,
  onReverseComplete,
  isMobile,
}) => {
  const { closeButtonRef } = refs3?.current || {};

  timeline3.current?.kill();
  timeline3.current = gsap.timeline({
    onComplete,
    onReverseComplete,
    paused: true,
  });

  timeline3.current.fromTo(
    closeButtonRef?.current,
    {
      x: '0',
    },
    {
      x: isMobile ? '38px' : '0',
      duration: 0.3,
      delay: 0.3,
      ease: ease,
    },
  );

  if (reversed) {
    timeline3.current.reverse(0);
  } else {
    timeline3.current.play();
  }
};
